import type { QuestionTranslateSchema } from '@repo/schemas/quiz/questionTranslate';

import { XIcon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button/ButtonGroup';

import type { QuestionTranslateFormOptionProps } from '.';

export function QuestionTranslateFormOption(questionTranslateFormOptionProps: QuestionTranslateFormOptionProps) {
  const { optionIndex, onRemoveOption, onSelectOption } = questionTranslateFormOptionProps;

  const { getValues } = useFormContext<QuestionTranslateSchema>();

  const value = getValues(`options.${optionIndex}`);

  const handleRemove = () => onRemoveOption(optionIndex);
  const handleSelect = () => onSelectOption(value);

  return (
    <ButtonGroup>
      <Button variant="outline" size="sm" type="button" className="bg-background" onClick={handleSelect}>
        {value.content}
      </Button>
      <Button variant="outline" className="bg-background" size="sm" type="button" onClick={handleRemove}>
        <XIcon />
      </Button>
    </ButtonGroup>
  );
}
